import { useQuery } from "@tanstack/react-query";
import { getVoiceAgents } from "../../api/agent/agent.api";
import { qk } from "../../lib/queryKeys";

export function useGetVoiceAgents(enabled: boolean) {
  return useQuery({
    queryKey: qk.voiceAgents(),
    queryFn: getVoiceAgents,
    enabled,
    staleTime: 60_000,
  });
}
